export const menucards = () => {

    const $menucard = $(".js-menu-card");
    const menucard = ".js-menu-card";

    const init = () => {
        bind();
    };
  
    const bind = () => {
        $menucard.on("click", function(evt) {
            evt.preventDefault();
            $(this).addClass("is-active");
        });
    };
  
   
    if ($menucard.length > 0) {
        init();
    }
    
  
};
  